module.exports = __webpack_public_path__ + "static/media/surprise.aa3d3fb6.svg";